"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTokenBase = exports.useSwappableTokens = exports.useTokenInfo = exports.useTokenListContext = exports.TokenListContextProvider = exports.SPL_REGISTRY_WORM_TAG = exports.SPL_REGISTRY_SOLLET_TAG = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var web3_js_1 = require("@solana/web3.js");
var token_instructions_1 = require("@project-serum/serum/lib/token-instructions");
var localStorage_1 = require("../utils/localStorage");
var pubkeys_1 = require("../utils/pubkeys");
var Token_1 = require("./Token");
var _TokenListContext = react_1.default.createContext(null);
// Tag in the spl-token-registry for sollet wrapped tokens.
exports.SPL_REGISTRY_SOLLET_TAG = "wrapped-sollet";
// Tag in the spl-token-registry for wormhole wrapped tokens.
exports.SPL_REGISTRY_WORM_TAG = "wormhole";
var SOL_TOKEN_INFO = {
    chainId: 101,
    address: pubkeys_1.SOL_MINT.toString(),
    name: "Native SOL",
    decimals: 9,
    symbol: "SOL",
    logoURI: "https://cdn.jsdelivr.net/gh/trustwallet/assets@master/blockchains/solana/info/logo.png",
    tags: [],
    extensions: {
        website: "https://solana.com/",
        serumV3Usdc: "9wFFyRfZBsuAha4YcuxcXLKwMxJR43S7fPfQLusDBzvT",
        serumV3Usdt: "HWHvQhFmJB3NUcu1aihKmrKegfVxBEHzwVX6yZCKEsi1",
        coingeckoId: "solana",
        waterfallbot: "https://t.me/SOLwaterfall",
    },
};
function TokenListContextProvider(props) {
    var userTokens = (0, Token_1.useTokenContext)().userTokens;
    var tokenList = (0, react_1.useMemo)(function () {
        var list = props.tokenList
            .filterByClusterSlug("mainnet-beta")
            .getList()
            .filter(function (token) { return token.decimals > 0; })
            .map(function (t) {
            if (t.address === token_instructions_1.WRAPPED_SOL_MINT.toString()) {
                // @ts-ignore
                t.symbol = "wSOL";
            }
            return t;
        });
        // Manually add a fake SOL mint for the native token. The component is
        // opinionated in that it distinguishes between wrapped SOL and SOL.
        list.push(SOL_TOKEN_INFO);
        return list;
    }, [props.tokenList]);
    // Token map for quick lookup.
    var tokenMap = (0, react_1.useMemo)(function () {
        var tokenMap = new Map();
        tokenList.forEach(function (t) {
            tokenMap.set(t.address, t);
        });
        return tokenMap;
    }, [tokenList]);
    // Tokens with USD(x) quoted markets.
    var swappableTokens = (0, react_1.useMemo)(function () {
        var allTokens = tokenList.filter(function (t) {
            var _a, _b;
            var isUsdxQuoted = ((_a = t.extensions) === null || _a === void 0 ? void 0 : _a.serumV3Usdt) || ((_b = t.extensions) === null || _b === void 0 ? void 0 : _b.serumV3Usdc);
            return isUsdxQuoted;
        });
        // Owned tokens sorted by moneyary worth
        var ownedTokens = allTokens
            .filter(function (token) {
            return (userTokens !== "fetching" && (userTokens === null || userTokens === void 0 ? void 0 : userTokens[token.address]) !== undefined);
        })
            .sort(function (a, b) {
            var _a, _b, _c, _d, _e, _f;
            var tokenA = (_a = userTokens) === null || _a === void 0 ? void 0 : _a[a.address];
            var aWorth = ((_b = tokenA === null || tokenA === void 0 ? void 0 : tokenA.tokenAmount) !== null && _b !== void 0 ? _b : 0) * ((_c = tokenA === null || tokenA === void 0 ? void 0 : tokenA.priceUsdt) !== null && _c !== void 0 ? _c : 0);
            var tokenB = (_d = userTokens) === null || _d === void 0 ? void 0 : _d[b.address];
            var bWorth = ((_e = tokenB === null || tokenB === void 0 ? void 0 : tokenB.tokenAmount) !== null && _e !== void 0 ? _e : 0) * ((_f = tokenB === null || tokenB === void 0 ? void 0 : tokenB.priceUsdt) !== null && _f !== void 0 ? _f : 0);
            return bWorth - aWorth;
        });
        // Not owned tokens in alphabetical order
        var notOwnedtokens = allTokens
            .filter(function (token) {
            var _a;
            return ((_a = userTokens) === null || _a === void 0 ? void 0 : _a[token.address]) === undefined;
        })
            .sort(function (a, b) {
            return a.symbol < b.symbol ? -1 : a.symbol > b.symbol ? 1 : 0;
        });
        return ownedTokens.concat(notOwnedtokens);
    }, [tokenList, tokenMap, userTokens]);
    // Sollet wrapped tokens.
    var _a = (0, react_1.useMemo)(function () {
        var tokens = tokenList.filter(function (t) {
            var _a;
            var isSollet = (_a = t.tags) === null || _a === void 0 ? void 0 : _a.includes(exports.SPL_REGISTRY_SOLLET_TAG);
            return isSollet;
        });
        tokens.sort(function (a, b) {
            return a.symbol < b.symbol ? -1 : a.symbol > b.symbol ? 1 : 0;
        });
        return [
            tokens,
            new Map(tokens.map(function (t) { return [t.address, t]; })),
        ];
    }, [tokenList]), swappableTokensSollet = _a[0], solletMap = _a[1];
    // Wormhole wrapped tokens.
    var _b = (0, react_1.useMemo)(function () {
        var tokens = tokenList.filter(function (t) {
            var _a;
            var isSollet = (_a = t.tags) === null || _a === void 0 ? void 0 : _a.includes(exports.SPL_REGISTRY_WORM_TAG);
            return isSollet;
        });
        tokens.sort(function (a, b) {
            return a.symbol < b.symbol ? -1 : a.symbol > b.symbol ? 1 : 0;
        });
        return [
            tokens,
            new Map(tokens.map(function (t) { return [t.address, t]; })),
        ];
    }, [tokenList]), swappableTokensWormhole = _b[0], wormholeMap = _b[1];
    var _c = (0, react_1.useState)(undefined), tokenBase = _c[0], setTokenBase = _c[1];
    var _d = (0, localStorage_1.LocalStorage)("swapui-common-bases"), addrList = _d[0], setValues = _d[1], removeValue = _d[2];
    // Common token bases
    (0, react_1.useEffect)(function () {
        var _a;
        if (addrList == null) {
            addrList = (_a = props.commonBases) !== null && _a !== void 0 ? _a : [];
        }
        if (props.commonBases) {
            props.commonBases.forEach(function (add) { return setValues(add.toString()); });
            addrList.concat(props.commonBases);
        }
        addrList = addrList.map(function (e) { return new web3_js_1.PublicKey(e.toString()); });
        var cb = addrList === null || addrList === void 0 ? void 0 : addrList.map(function (add) {
            var token = tokenMap.get(add.toString());
            if (token) {
                // save in react state
                token.isCommonBase = true;
                // save in persistent storage
                setValues(token.address);
            }
            return token;
        });
        setTokenBase(cb);
        return cb;
    }, [props.commonBases]);
    var addNewBase = function (token) {
        // Check if token already a common base
        if (tokenBase === null || tokenBase === void 0 ? void 0 : tokenBase.some(function (t) { return token.address.toString() === t.address.toString(); })) {
            return;
        }
        var c = __assign(__assign({}, token), { isCommonBase: true });
        setValues(token.address);
        setTokenBase(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [c], false); });
    };
    var removeBase = function (token) {
        var _a;
        var index = (_a = tokenBase === null || tokenBase === void 0 ? void 0 : tokenBase.findIndex(function (t) { return token.address.toString() === t.address.toString(); })) !== null && _a !== void 0 ? _a : -1;
        // return if not found
        if (index == -1)
            return;
        var tempTokenBase = tokenBase === null || tokenBase === void 0 ? void 0 : tokenBase.slice();
        tempTokenBase === null || tempTokenBase === void 0 ? void 0 : tempTokenBase.splice(index, 1);
        setTokenBase(tempTokenBase);
        removeValue(index);
    };
    // Token map for quick lookup.
    var tokenBaseMap = (0, react_1.useMemo)(function () {
        var tokenBaseMap = new Map();
        tokenBase === null || tokenBase === void 0 ? void 0 : tokenBase.forEach(function (t) {
            tokenBaseMap.set(t.address, t);
        });
        return tokenBaseMap;
    }, [tokenBase]);
    return ((0, jsx_runtime_1.jsx)(_TokenListContext.Provider, __assign({ value: {
            tokenMap: tokenMap,
            wormholeMap: wormholeMap,
            solletMap: solletMap,
            swappableTokens: swappableTokens,
            swappableTokensWormhole: swappableTokensWormhole,
            swappableTokensSollet: swappableTokensSollet,
            tokenBase: tokenBase,
            addNewBase: addNewBase,
            removeBase: removeBase,
            tokenBaseMap: tokenBaseMap,
        } }, { children: props.children }), void 0));
}
exports.TokenListContextProvider = TokenListContextProvider;
function useTokenListContext() {
    var ctx = (0, react_1.useContext)(_TokenListContext);
    if (ctx === null) {
        throw new Error("Context not available");
    }
    return ctx;
}
exports.useTokenListContext = useTokenListContext;
function useTokenInfo(tokenMint) {
    var tokenMap = useTokenListContext().tokenMap;
    if (!tokenMint) {
        return undefined;
    }
    return tokenMap.get(tokenMint.toString());
}
exports.useTokenInfo = useTokenInfo;
function useSwappableTokens() {
    var _a = useTokenListContext(), swappableTokens = _a.swappableTokens, swappableTokensWormhole = _a.swappableTokensWormhole, swappableTokensSollet = _a.swappableTokensSollet;
    return {
        swappableTokens: swappableTokens,
        swappableTokensWormhole: swappableTokensWormhole,
        swappableTokensSollet: swappableTokensSollet,
    };
}
exports.useSwappableTokens = useSwappableTokens;
function useTokenBase() {
    var _a = useTokenListContext(), tokenBase = _a.tokenBase, addNewBase = _a.addNewBase, tokenBaseMap = _a.tokenBaseMap, removeBase = _a.removeBase;
    return {
        tokenBase: tokenBase,
        addNewBase: addNewBase,
        tokenBaseMap: tokenBaseMap,
        removeBase: removeBase,
    };
}
exports.useTokenBase = useTokenBase;
